import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_product_group",
  tabindex: -1,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "form-label fw-bold text-dark fs-6" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_10 = { class: "mb-5 d-flex align-items-center" }
const _hoisted_11 = { class: "form-check form-switch form-check-custom form-check-solid me-3" }
const _hoisted_12 = {
  class: "form-label fw-bold text-dark fs-6 mb-0",
  for: "allow_discount"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = { class: "form-label fw-bold text-dark fs-6 d-flex justify-content-between align-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = {
  key: 0,
  class: "text-danger fs-7"
}
const _hoisted_18 = { class: "form-label fw-bold text-dark fs-6" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "modal-footer flex-center" }
const _hoisted_21 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_22 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.productGroupData,
          rules: _ctx.formRules,
          ref: "addProductGroupForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.ADD')} ${_ctx.$t('message.PRODUCT_GROUPS')}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_el_form_item, {
                  prop: "name",
                  class: "mb-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode("label", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.NAME')) + " ", 1),
                      _hoisted_9
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.productGroupData.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.productGroupData.name = $event)),
                      placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                      class: "w-100"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "allow_discount",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.productGroupData.allow_discount = $event)),
                      style: _ctx.productGroupData.allow_discount ? 'background-color: #8D1317; border-color: #8D1317;' : 'background-color: #6c757d; border-color: #6c757d;'
                    }, null, 4), [
                      [_vModelCheckbox, _ctx.productGroupData.allow_discount]
                    ])
                  ]),
                  _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('message.ALLOW_DISCOUNT')), 1)
                ]),
                (_ctx.productGroupData.allow_discount)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("label", _hoisted_15, [
                          _createVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.DISCOUNT_TYPE')) + " ", 1),
                            (_ctx.productGroupData.allow_discount)
                              ? (_openBlock(), _createBlock("span", _hoisted_16, "*"))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.discountTypeError)
                            ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.discountTypeError), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_select, {
                          required: _ctx.productGroupData.allow_discount,
                          modelValue: _ctx.productGroupData.discount_type,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.productGroupData.discount_type = $event)),
                          placeholder: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.DISCOUNT_TYPE')}`,
                          class: "w-100",
                          onChange: _ctx.clearDiscountTypeError
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('message.PERCENTAGE'),
                              value: "percentage"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('message.VALUE'),
                              value: "value"
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["required", "modelValue", "placeholder", "onChange"])
                      ]),
                      _createVNode(_component_el_form_item, {
                        prop: "discount_value",
                        class: "mb-5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("label", _hoisted_18, [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.DISCOUNT_VALUE')) + " ", 1),
                            (_ctx.productGroupData.allow_discount)
                              ? (_openBlock(), _createBlock("span", _hoisted_19, "*"))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.productGroupData.discount_value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.productGroupData.discount_value = $event)),
                            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.DISCOUNT_VALUE')}`,
                            class: "w-100"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("button", _hoisted_21, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}